import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GetIsPlayingPcapGQL } from '@uigy/generated/graphql';
import { IemService } from '@uigy/shared/services/iem.service';
import Utils from '@uigy/utils';

@Injectable({
  providedIn: 'root'
})
export class PcapPlayerIndicatorService {
  isPlaying$: Observable<boolean> = this.iemService.isIEM() ? of(false) : this.getIsPlayingPcapGQL.subscribe()
    .pipe(
      Utils.fetchResultOperator(),
      map(({ pcapPlayerStatus }) => pcapPlayerStatus.isPlaying),
      catchError(() => [false]),
    );

  constructor(
    private getIsPlayingPcapGQL: GetIsPlayingPcapGQL,
    private iemService: IemService,
  ) {
  }
}
